import Vue from 'vue'
import axios from "axios";

let config = {
  baseURL: process.env.VUE_APP_SCAN_API_URL,
  responseType: 'json',
  headers: {},
};

const _axios = axios.create(config);
Vue.prototype.$scanApi = _axios;
